import { Action, createReducer, on } from '@ngrx/store';
import { Device } from '../../../models/device';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as deviceActions from '../../state/device/device.actions';

export interface DeviceState extends EntityState<Device> {
  loadingDevices: boolean;
  devicesLoaded: boolean;
  selectedDevice: Device;
}

export const deviceAdapter: EntityAdapter<Device> = createEntityAdapter<Device>({});

export const initialDeviceState: DeviceState = deviceAdapter.getInitialState({
  loadingDevices: false,
  devicesLoaded: false,
  selectedDevice: null,
});

export const reducer = createReducer(
  initialDeviceState,
  on(deviceActions.getDevice, (state) => {
    return {
      ...state,
    };
  }),
  on(deviceActions.getDeviceSuccess, (state, { device }) => {
    return deviceAdapter.addOne(device, {
      ...state,
      selectedDevice: device,
    });
  }),
  on(deviceActions.getDeviceError, (state) => {
    return {
      ...state,
    };
  }),
  on(deviceActions.getDevices, (state) => {
    return {
      ...state,
      loadingDevices: true,
      devicesLoaded: false,
    };
  }),
  on(deviceActions.getDevicesSuccess, (state, { devices }) => {
    return deviceAdapter.setAll(devices, {
      ...state,
      loadingDevices: false,
      devicesLoaded: true,
    });
  }),
  on(deviceActions.getDevicesError, (state) => {
    return {
      ...state,
      loadingDevices: false,
      devicesLoaded: false,
    };
  }),
  on(deviceActions.editDeviceTag, (state) => {
    return {
      ...state,
    };
  }),
  on(deviceActions.editDeviceTagSuccess, (state, { device }) => {
    return deviceAdapter.addOne(device, {
      ...state,
      selectedDevice: device,
    });
  }),
  on(deviceActions.editDeviceTagError, (state) => {
    return {
      ...state,
    };
  }),
  on(deviceActions.saveUnusedDeviceSuccess, (state, { device }) => {
    return deviceAdapter.addOne(device, {
      ...state,
      selectedDevice: device,
    });
  }),
  on(deviceActions.saveUnusedDeviceError, (state) => {
    return {
      ...state,
    };
  })
);

export function deviceReducer(state: DeviceState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = deviceAdapter.getSelectors();
